<template>
    <card shadow>
      <div class="pt-4 text-left">
        <h5 class="h1 title">
          <span class="d-block">Complete sign up as a:</span>
        </h5>
      </div>
      <tabs fill class="flex-column flex-md-row">
        <card>
          <!--<tab-pane>
            <span slot="title">
              <i class="ni ni-satisfied" />
              Participant
            </span>
            <p class="description">

            </p>
          </tab-pane>-->
          <tab-pane title="Profile">
            <span slot="title">
              <i class="ni ni-briefcase-24 mr-2" />
              Employer
            </span>
            <joinorg-get-started orgType="Employer"/>
          </tab-pane>
          <tab-pane>
            <span slot="title">
              <i class="ni ni-favourite-28" />
              Partner/Agency
            </span>
            <joinorg-get-started orgType="Partner/Agency"/>
          </tab-pane>
        </card>
      </tabs>
    </card>
</template>

<script>
import JoinOrgGetStarted from '@/views/dashboard/components/JoinOrgGetStarted.vue'

export default {
  name: "getstarted",
  components: {
    'joinorg-get-started': JoinOrgGetStarted,
  },
};
</script>

<style scoped>
</style>
